import type { LanguageCode } from '../types';

export const roadbookLandmarkLabels: Record<LanguageCode, string> = {
  EN: 'Roadbook',
  DE: 'Routenbuch',
  ES: 'Libro de ruta',
  IT: 'Libro di viaggio',
  FR: 'Carnet de route'
};

export const journeyTabLabels: Record<LanguageCode, { sections: string; plan: string; roadbook: string; profile: string }> = {
  EN: { sections: 'Journey sections', plan: 'Plan', roadbook: 'Roadbook', profile: 'Profile' },
  DE: { sections: 'Reisebereiche', plan: 'Plan', roadbook: 'Routenbuch', profile: 'Profil' },
  ES: { sections: 'Secciones del viaje', plan: 'Plan', roadbook: 'Libro de ruta', profile: 'Perfil' },
  IT: { sections: 'Sezioni del viaggio', plan: 'Piano', roadbook: 'Libro di viaggio', profile: 'Profilo' },
  FR: { sections: 'Sections du voyage', plan: 'Plan', roadbook: 'Carnet de route', profile: 'Profil' }
};

export const journeyUiLabels: Record<LanguageCode, {
  compact: string; medium: string; expanded: string;
  alternatives: string; active: string; inactive: string; focused: string;
  focus: string; activate: string; deactivate: string;
}> = {
  EN: { compact: 'Compact', medium: 'Medium', expanded: 'Expanded', alternatives: 'Route alternatives', active: 'Active', inactive: 'Inactive', focused: 'Focused', focus: 'Focus', activate: 'Activate', deactivate: 'Deactivate' },
  DE: { compact: 'Kompakt', medium: 'Mittel', expanded: 'Erweitert', alternatives: 'Routenalternativen', active: 'Aktiv', inactive: 'Inaktiv', focused: 'Im Fokus', focus: 'Fokussieren', activate: 'Aktivieren', deactivate: 'Deaktivieren' },
  ES: { compact: 'Compacta', medium: 'Media', expanded: 'Ampliada', alternatives: 'Alternativas de ruta', active: 'Activa', inactive: 'Inactiva', focused: 'En primer plano', focus: 'Enfocar', activate: 'Activar', deactivate: 'Desactivar' },
  IT: { compact: 'Compatta', medium: 'Media', expanded: 'Estesa', alternatives: 'Alternative di percorso', active: 'Attiva', inactive: 'Inattiva', focused: 'In primo piano', focus: 'Metti a fuoco', activate: 'Attiva', deactivate: 'Disattiva' },
  FR: { compact: 'Compacte', medium: 'Moyenne', expanded: 'Étendue', alternatives: 'Itinéraires alternatifs', active: 'Actif', inactive: 'Inactif', focused: 'Au premier plan', focus: 'Afficher', activate: 'Activer', deactivate: 'Désactiver' }
};
